import axios from 'axios';
import { message } from 'antd';

// 创建 Axios 实例
const instance = axios.create({
    baseURL: 'https://cybersphereinstitute.xyz',  // 设置你的 API 基础 URL
});

// 请求拦截器
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.data.code === -5) {
            // token 过期
            message.error('您的 session 已过期，请重新登录');

            // 使用传递过来的 navigate 来跳转到登录页
            const { navigate } = error.config;  // 获取传递的 navigate
            if (navigate) {
                navigate('/login');  // 跳转到登录页面
            }

            // 清除本地存储中的 token
            localStorage.removeItem('token');
        }
        return Promise.reject(error);
    }
);

export default instance;
